export default __webpack_public_path__ + "static/media/product-17 (1).3eb34735.jpg";